import React from 'react';
import { useSelector } from 'react-redux';
import {
  Inventory,
  ListAlt,
  LocalShipping,
  Payment,
  PriceChange,
  ShoppingCart,
} from '@mui/icons-material';
import './profileLayout.css';
import { secondaryPermission } from '../../utils/settings';
import GlobalSidebar from '../Global Sidebar/GlobalSidebar';
const iconSx = { color: '#ffffff' };

const MyBusinessSideBar = () => {
  const { secondaryPermissionsRoles } = useSelector((state) => {
    return {
      secondaryPermissionsRoles: state.loginReducer.secondaryPermissionsRoles,
    };
  });
  const ORDER_ADMIN = secondaryPermissionsRoles?.includes(
    secondaryPermission['ORDER_ADMIN'],
  );
  const PAYMENT_ADMIN = secondaryPermissionsRoles?.includes(
    secondaryPermission['PAYMENT_ADMIN'],
  );
  const COMPANY_ADMIN = secondaryPermissionsRoles?.includes(
    secondaryPermission['COMPANY_ADMIN'],
  );
  const manageTabList = [
    {
      title: 'My Business',
      tabs: [
        {
          iconSource: <ShoppingCart sx={iconSx} />,
          title: 'PO/Order Booking',
          navigateTo: '/order-booking/po-select-industry',
          bgColor: '#FF9201',
          isVisible: ORDER_ADMIN || COMPANY_ADMIN,
        },
        {
          iconSource: <ListAlt sx={iconSx} />,
          title: 'Purchase orders',
          navigateTo: '/order-booking/po-list',
          bgColor: '#FF9201',
          isVisible: PAYMENT_ADMIN || ORDER_ADMIN || COMPANY_ADMIN,
        },
        {
          iconSource: <LocalShipping sx={iconSx} />,
          title: 'Dispatch Status',
          navigateTo: '/order-booking/dispatch-status-list',
          bgColor: '#FF9201',
          isVisible: PAYMENT_ADMIN || ORDER_ADMIN || COMPANY_ADMIN,
        },
        {
          iconSource: <ListAlt sx={iconSx} />,
          title: 'Secondary Orders',
          navigateTo: '/order-booking/secondar-orders-list',
          bgColor: '#FF9201',
          isVisible: ORDER_ADMIN || COMPANY_ADMIN,
        },
        {
          iconSource: <LocalShipping sx={iconSx} />,
          title: 'Completed Invoices',
          navigateTo: '/order-booking/completed-invoices',
          bgColor: '#FF9201',
          isVisible: PAYMENT_ADMIN || ORDER_ADMIN || COMPANY_ADMIN,
        },
        {
          iconSource: <Inventory sx={iconSx} />,
          title: 'Inventory',
          navigateTo: '/distributor/company-wise-inventory',
          bgColor: '#FF9201',
          isVisible: PAYMENT_ADMIN || ORDER_ADMIN || COMPANY_ADMIN,
        },
        {
          iconSource: <PriceChange sx={iconSx} />,
          title: 'Product Pricing',
          navigateTo: '/distributor/productPricing',
          bgColor: '#FF9201',
          isVisible: false,
          // hide as we don’t have Any tmt Live (PLAT-3603)
        },
        {
          iconSource: <Payment sx={iconSx} />,
          title: 'Payment',
          navigateTo: '/distributor/payment',
          bgColor: '#FF9201',
          isVisible: PAYMENT_ADMIN || COMPANY_ADMIN,
        },
        {
          iconSource: <Payment sx={iconSx} />,
          title: 'Payment History',
          navigateTo: '/distributor/paymentHistory',
          bgColor: '#FF9201',
          isVisible: PAYMENT_ADMIN || COMPANY_ADMIN,
        },
      ].filter((tab) => tab.isVisible),
    },
  ];
  return <GlobalSidebar sections={manageTabList} />;
};

export default MyBusinessSideBar;
